<div>
    <button *ngIf="hasGrafanaValueButton" mat-button color="primary" class="schema-button" (click)="openGrafanaDrawer()">Current Values</button>
    <button *ngIf="hasGrafanaHistoryButton" mat-button color="primary" (click)="openGrafanaHistoryDrawer()">Historical Values</button>
</div>
